import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { ProviderService } from '@services/provider.service';
import { requiredFileType, requiredFileSize } from '@utils/validators';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { SelectModule } from 'primeng/select';
import { ToastService } from '@utils/toast.service';
import { TableModule } from 'primeng/table';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SatService } from '@services/sat.service';

@Component({
  selector: 'app-upload',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TabViewModule,
    InputTextModule,
    SelectModule,
    TableModule,
    InputGroupAddonModule,
    InputGroup,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
})
export class UploadComponent {
  private formBuilder = inject(FormBuilder);
  private satService = inject(SatService);
  private providerService = inject(ProviderService);
  private toastService = inject(ToastService);

  public apiUrl = environment.app.apiUrl;
  public maxSizesUpload = 3000000;
  public isUploading = false;

  public formUpload = this.formBuilder.group({
    files: this.formBuilder.array([]),
    provider: [null, [Validators.required]],
  });

  public providers: any[] = [];
  public list: any[] = [];
  public searchValue: string | undefined;

  ngOnInit() {
    this.providerService.module('sat-recuperacion-cfdi').then((data) => (this.providers = data));

    this.refresh();
  }

  refresh = async () => {
    await this.satService.recuperacionCfdiList().then((response) => (this.list = response));
  };

  get provider() {
    return this.formUpload.get('provider');
  }

  get files(): FormArray {
    return this.formUpload.controls['files'] as FormArray;
  }
  getFilesAsIndex = (index: number, get = 'file') => this.files.controls[index].get(get);

  onInputFileChanged = (event: any) => {
    if (event.target.files && event.target.files.length) {
      for (const element of event.target.files) {
        let reader = new FileReader();

        reader.onload = (e: any) => {
          this.files.push(
            this.formBuilder.group({
              file: [element, [requiredFileType(['pdf']), requiredFileSize(this.maxSizesUpload)]],
              url: e.target.result, // Base64 string for preview image,
              upload: false,
            })
          );
        };

        reader.readAsDataURL(element);
      }
    }

    event.target.value = null;
  };

  removeFile = (index: number) => this.files.removeAt(index);

  upload = async () => {
    this.isUploading = true;

    const myFormData = new FormData();

    myFormData.append('provider', this.provider?.value ?? '');

    for (const [index, item] of this.files.value.entries()) {
      if (this.getFilesAsIndex(index)?.errors === null) {
        myFormData.append('files[]', item.file, item.file.name);
      }
    }

    this.satService
      .recuperacionCfdiUpload(myFormData)
      .then(() => {
        this.files.clear();
        this.refresh();
      })
      .catch((err) => this.toastService.error(err.error.data.message || 'Error al subir los archivos.'))
      .finally(() => (this.isUploading = false));
  };
}
